import { ConfidenceBanner, modelConfidence } from './ui'
import { AddBlockPanel } from './AddBlockPanel'
import { BlockCard, DataQualityBanner, PlanControlBar } from './PlanComponents'
import type { BlacklistRule, Block, PredictResponse } from './domain'
import type { EditablePlan } from './useEditablePlan'

export function PlanEditor({ result, nmcMode, blacklist, plan, onExplore }: {
  result: PredictResponse
  nmcMode: boolean
  blacklist: BlacklistRule[]
  plan: EditablePlan
  onExplore?: (block: Block) => void
}) {
  const { lines, blocks, planN, onPlanN, allocation, pinnedCount, editCount,
    setPin, unpin, setBlockPin, unpinBlock, removeLine, addLine,
    deleteBlock, addBlock, setBlockAddons, resetEdits } = plan
  const modelBlocks = blocks.filter(b => b.source !== 'user')
  const { score: modelConf, label: modelLabel } = modelConfidence(blocks)
  return (
    <>
      <DataQualityBanner dq={result.data_quality} />
      <ConfidenceBanner
        label={modelLabel}
        score={modelConf}
        lowBlocks={modelBlocks.filter(b => b.confidence_label === 'LOW').length}
        totalBlocks={modelBlocks.length}
        noData={modelBlocks.length === 0}
      />

      {allocation && (
        <PlanControlBar
          planN={planN} onPlanN={onPlanN}
          total={allocation.total} status={allocation.status} message={allocation.message}
          pinnedCount={pinnedCount} editCount={editCount} onReset={resetEdits}
        />
      )}

      <div className="space-y-6">
        {blocks.map(block => (
          <BlockCard
            key={block.rank} block={block}
            lines={lines.filter(l => l.blockRank === block.rank)}
            descriptions={result.option_descriptions} packageContents={result.package_contents ?? {}} nmcMode={nmcMode}
            modelCodes={result.model_codes} blacklist={blacklist}
            quantities={allocation?.quantities ?? {}}
            onPin={setPin} onUnpin={unpin} onRemove={removeLine} onAdd={addLine}
            onDeleteBlock={deleteBlock} onBlockPin={setBlockPin} onUnpinBlock={unpinBlock}
            allBlocks={blocks} onSetAddons={setBlockAddons} onExplore={onExplore}
          />
        ))}
      </div>

      <AddBlockPanel
        modelCodes={result.model_codes} nmcMode={nmcMode}
        present={new Set([
          ...blocks.map(b => [...b.packages].sort().join('|')),
          ...blocks.filter(b => b.nmc_model_code).map(b => b.nmc_model_code as string),
        ])}
        onAdd={addBlock}
      />
    </>
  )
}
